import styled from 'styled-components'

export const ToggleContainer = styled.div`
  display: flex;
  background: ${({ theme }) =>
    theme?.colors?.background?.tertiary ?? '#F5F5F5'};
  border-radius: ${({ theme }) => theme?.borderRadius?.medium ?? '8px'};
  padding: 3px;
  gap: 2px;
`

export const ToggleButton = styled.button<{ $active?: boolean }>`
  padding: ${({ theme }) =>
    `${theme?.spacing?.xsmall ?? '4px'} ${theme?.spacing?.small ?? '8px'}`};
  border: none;
  background: ${({ $active, theme }) =>
    $active
      ? (theme?.colors?.background?.primary ?? '#FFFFFF')
      : 'transparent'};
  border-radius: ${({ theme }) => theme?.borderRadius?.small ?? '4px'};
  font-size: ${({ theme }) => theme?.typography?.fontSize?.small ?? '13px'};
  font-weight: 500;
  color: ${({ $active, theme }) =>
    $active
      ? (theme?.colors?.primary ?? '#00ADE6')
      : (theme?.colors?.text?.secondary ?? '#6B6B6B')};
  cursor: pointer;
  transition: all ${({ theme }) => theme?.transitions?.default ?? '0.2s ease'};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme?.spacing?.xsmall ?? '4px'};
  font-family: inherit;
  box-shadow: ${({ $active, theme }) =>
    $active ? (theme?.shadows?.sm ?? '0 1px 2px rgba(0,0,0,0.04)') : 'none'};
  white-space: nowrap;

  &:hover {
    color: ${({ $active, theme }) =>
      $active
        ? (theme?.colors?.primary ?? '#00ADE6')
        : (theme?.colors?.text?.primary ?? '#1A1A1A')};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`
